// GLOBAL mutations
/* eslint-disable */
import types from './types';

export default {
  [types.SHOW_NOTIFICATION_BAR]: (state, payload) => {
    //Upload shipment/customer specific header error, received through exception
    if (payload.message && payload.message.hasOwnProperty('type') && payload.message.type === 'header_error') {
      state.errorMessage = payload;
      return;
    }
    // Upload shipment/customer specific row error, received in file upload process
    // Mutations triggered in: src/components/global/uploadTemplate/index.vue
    if (payload.hasOwnProperty('type') && payload.type === 'row_error') {
      state.errorMessage = payload;
      return;
    }

    state.notification = payload;
    state.errorMessage = payload;
    let timeout = 5000;
    if( payload.type.success-window ) timeout = 10000;
    if(payload.hasOwnProperty('closeOnClick')) return;
    setTimeout(() => {
      state.errorMessage = '';
      state.notification = {
        message: '',
        type: '',
        iconName: '',
      };
    }, timeout)
  },
  [types.CLOSE_NOTIFICATION_BAR]: (state) => {
    state.errorMessage = '';
    state.notification = {
        message: '',
        type: '',
        iconName: '',
      };
  },
  [types.RESET_NOTIFICATION_BAR]: (state) => {
    state.errorMessage = '';
    state.notification = {
      message: '',
      type: '',
      iconName: '',
    };
  },
  [types.STORE_LANGUAGE]: (state, payload) => {
    state.language = payload;
  },
  [types.STORE_IN_QUEUE]: (state, payload) => {
    state.importQueue.push(payload);
  },
  [types.UPDATE_IN_QUEUE]: (state, payload) => {
    state.importQueue = state.importQueue.map((que) => {
      if(que.progressId == payload.progressId) {
        return {...que, progressStatus: payload.progressStatus};
      } else {
        return que;
      }
    });
  },
  [types.REMOVE_FROM_QUEUE]: (state, payload) => {
    state.importQueue = state.importQueue.filter(opt => opt.progressId !== payload);
    state.importQueueIds = state.importQueueIds.filter(opt => opt !== payload);
  },
  [types.STORE_ID_QUEUE]: (state, payload) => {
    state.importQueueIds.push(payload);
  },
  SET_FORCE_REDIRECT(state, path) {
    state.forceRedirect = path
  },
};
